import { Building } from 'lucide-react';
import { AdminLayout } from '../../components/admin/layout/AdminLayout';
import { ComingSoon } from '../../components/admin/ui';

export function CRMOrganizationsPage() {
  return (
    <AdminLayout
      title="Organisations"
      description="Base de données des entreprises clientes et prospects"
    >
      <ComingSoon
        icon={Building}
        title="Gestion des Organisations"
        description="Centralisez toutes les informations sur vos entreprises clientes et prospects."
        features={[
          'Fiches entreprises complètes avec données enrichies',
          'Hiérarchie et relations entre organisations',
          'Contacts associés et organigramme',
          'Historique des interactions et contrats',
          'Indicateurs de santé client',
        ]}
      />
    </AdminLayout>
  );
}
